import React from "react";
import "./slideshow.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SlideShow(props) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
  };

  return (
    <div>
      <Slider {...settings}>
        {props.slides.map((slide, index) => (
          <div key={index} className="slideshow">
            <img
              src={slide.src}
              alt={slide.alt}
              className={`${!props.karim && "slide-image"} img-fluid rounded`}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default SlideShow;
